import { $t } from "@/plugins/i18n"

import { ItemType } from "./Item"

export class Type {
  readonly id: ItemType
  label?: string

  constructor({ label, id }: { label: string; id: ItemType }) {
    this.id = id
    this.label = label
  }
}

export const typeCreateById = ({ id }: { id: string }): Type => {
  const label = $t(`backlog.itemTypeToTitle.${id}`) as string
  return new Type({ id: id as ItemType, label })
}
